import { render, staticRenderFns } from "./IconPencil.vue?vue&type=template&id=08d1c640&scoped=true&lang=pug&"
import script from "./IconPencil.vue?vue&type=script&lang=js&"
export * from "./IconPencil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d1c640",
  null
  
)

export default component.exports